controllers.controller('DepositController', [
    '$scope', '$rootScope', '$state', '$ionicLoading',
    'config', 'constants', 'Utils', 'UserService', 'LocaleService', 'API', 'Storage', '$sce', 'appsflyer',
    function ($scope, $rootScope, $state, $ionicLoading,
              config, Const, Utils, UserService, LocaleService, API, Storage, $sce, appsflyer) {

        LocaleService.wait().then(function (translation) {
            $scope.translation = translation;
        });

        // $scope.constants = Const;

        // var user = UserService.get();

        // var options = {
        //     location: 'no',
        //     clearcache: 'yes',
        //     toolbar: 'no',
        //     zoom: 'no',
        //     hardwareback: 'no',
        //     hidden: 'yes',
        //     closebuttoncaption: LocaleService.translation.back
        // };

        // if (Storage.get('platform') === 'ios') {
        //     options.toolbar = 'yes';
        // }

        // $scope.modal = {
        //     actionText: LocaleService.translation.try_again,
        //     state: false,
        //     isError: false,
        //     back: "app.assets"
        // };


        // var userWatch = $scope.$watch(UserService.get, function (newVal, oldVal) {
        //     if (newVal !== oldVal && newVal) {
        //         $scope.user = UserService.get();
        //     }
        // });
        //
        // var statusWatch = $scope.$watch(API.status, function (newVal, oldVal) {
        //     if (newVal !== oldVal && !newVal) {
        //         API.unsubscribe('CreditCardDepositConfirm');
        //         $state.go('app.assets', {cache: false});
        //     }
        // });

        // if (user && user.activeAccountId) {
        //     var depositUrl = config.depositUrl + '?uid=' + user.userID + '&login=' + user.activeAccountId;
        //     $scope.iframeUrl = $sce.trustAsResourceUrl(depositUrl);
        //
        //     $scope.loadingMessage = LocaleService.translation.loading_deposit;
        //     $ionicLoading.show({templateUrl: 'templates/directives/message-spinner.html', scope: $scope});
        // }

        // $scope.iframeReady = false;

        // $scope.iframeLoad = function () {
        //     $ionicLoading.hide();
        //     API.subscribe('CreditCardDepositConfirm', depositResult);
        //     $scope.iframeReady = true;
        // };

        // $scope.iframeLoadFail = function () {
        //     $ionicLoading.hide();
        //     API.unsubscribe('CreditCardDepositConfirm');
        //
        //     $scope.iframeReady = false;
        //     $scope.iframeUrl = '';
        //
        //     $scope.modal.isError = true;
        //     $scope.modal.textTitle = LocaleService.translation.messages.inappFailed;
        //     $scope.modal.state = true;
        // };

        function depositResult(data) {
            API.unsubscribe('CreditCardDepositConfirm');

            if (data.Code != "1") {
                $scope.modal.isError = true;
                $scope.modal.textTitle = LocaleService.translation.messages.depositFailed;
                $scope.modal.textContent = LocaleService.translation.messages[data.Description] || LocaleService.translation.messages.Err600;
            }

            if (data.Code == "1") {
                appsflyer.trackEvent("deposit", {
                    "user": user.email,
                    "currency": data.Currency,
                    "amount": data.Amount
                });

                $scope.modal.isError = false;
                $scope.modal.textTitle = LocaleService.translation.messages.depositSuccess;
                $scope.modal.textContent =
                    [
                        ['Amount:', parseFloat(data.Amount).toFixed(2), data.Currency].join(' '),
                        'Transaction ID: #' + data.TransactionID + '&zwj;'
                    ].join('<br/>')
            }

            $scope.modal.state = true;
            $scope.modal.actionText = LocaleService.translation.continueTrading;
            $scope.back = "root.app.assets";
        }

        // $scope.$on('clear', function () {
        //     statusWatch();
        //     userWatch();
        // });
        //
        // $scope.$on('$ionicView.beforeLeave', function () {
        //     API.unsubscribe('CreditCardDepositConfirm');
        //     $scope.iframeReady = false;
        //     $scope.iframeUrl = '';
        // });
        //
        // $scope.$on('$ionicView.beforeEnter', function () {
        //     if (user.registrationPhase != "2") {
        //         $state.go('longreg', {cache: false});
        //     }
        // });

        // $scope.close = function () {
        //     API.unsubscribe('CreditCardDepositConfirm');
        //     $scope.iframeReady = false;
        //     $scope.iframeUrl = '';
        //     $state.go('app.assets', {cache: false});
        // }

    }]);
